<template>
    <BasePanel
        headline='lang_AZ_GROUPS_PANEL_CAPTION_FINANCE'
        helpContext="AzPersonsEditPanelFinance"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row class="pt-4">
                    <v-col>
                        <BaseEditPageTextarea 
                            :context="context"
                            field="PaymentOrder"
                            rows="3"
                            :label="paymentOrderLabel"
                            :alvqa="alvqa + '-textarea-payment-order'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="AccountHolder"
                            :label="accountHolderNoLabel"
                            :alvqa="alvqa + '-textfield-account-holder'"
                        />
                    </v-col>
                    <!-- TODO: rule, only positive integers -->
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="PaymentTarget"
                            :label="paymentTargetLabel"
                            :alvqa="alvqa + '-textfield-payment-target'"
                        />
                    </v-col>
                    <v-col>
                        <!--  TODO rule for ust-id -->
                        <BaseEditPageTextField 
                            :context="context"
                            field="VatId"
                            :label="vatIdLabel"
                            :alvqa="alvqa + '-textfield-vat-id'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Iban"
                            :label="accountNumberLabel"
                            :alvqa="alvqa + '-textfield-iban'"
                        />
                    </v-col>
                    <v-col cols="2">
                        <BaseEditPageTextField 
                            :context="context"
                            field="VatRetail"
                            rules="percentDecimal"
                            :label="vatRetailLabel"
                            :alvqa="alvqa + '-textfield-vat-retail'"
                        />
                    </v-col>
                    <v-col cols="2">
                        <BaseEditPageTextField 
                            :context="context"
                            field="VatLicense"
                            rules="percentDecimal"
                            :label="vatLicenseLabel"
                            :alvqa="alvqa + '-textfield-vat-license'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxOffice"
                            :label="taxOfficeLabel"
                            :alvqa="alvqa + '-textfield-tax-office'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Bic"
                            :label="bicLabel"
                            :alvqa="alvqa + '-textfield-bic'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="RegistrationNumber"
                            :label="registrationNumberLabel"
                            :alvqa="alvqa + '-textfield-registration-number'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxNumber"
                            :label="taxNumberLabel"
                            :alvqa="alvqa + '-textfield-tax-number'"
                            
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="BankName"
                            :label="bankNameLabel"
                            :alvqa="alvqa + '-textfield-bank-name'"
                        />
                    </v-col>
                     <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="RegisterCourt"
                            :label="registerCourtLabel"
                            :alvqa="alvqa + '-textfield-register-court'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxIdNumber"
                            :label="taxIdNumberLabel"
                            :alvqa="alvqa + '-textfield-tax-id-number'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField
                            :context="context"
                            field="BankDataLocalized"
                            rules="bankDataLocalized"
                            :label="$t('lang_GENERIC_CAPTION_BANK_DATA_LOCALIZED')"
                            :alvqa="alvqa + '-textfield-bank-data-localized'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <BaseEditPageDropdown 
                            :context="context"
                            field="TaxWaiver"
                            :items="taxWaiverItems" 
                            :label="taxWaiverLabel" 
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-tax-waiver'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="TaxWaiverFrom"
                            :label="taxWaiverFromLabel"
                            :alvqa="alvqa + '-datepicker-tax-waiver-from'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="TaxWaiverTo"
                            :label="taxWaiverToLabel"
                            :alvqa="alvqa + '-datepicker-tax-waiver-to'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxWithholdingPercentage"
                            :label="taxWithholdingPercentageLabel"
                            :rules="withholdingRules"
                            numberFormat="decimal3"
                            :iconTooltipText="$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_TAX_PERCENTAGE_HELP')"
                            :alvqa="alvqa + '-textfield-tax-withholding-percentage'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField
                            :context="context"
                            field="TaxWithholdingSurchargePercentage"
                            :label="taxWithholdingSurchargePercentageLabel"
                            rules="percentDecimal3"
                            numberFormat="decimal3"
                            :alvqa="alvqa + '-textfield-tax-withholding-surcharge-percentage'"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TaxLiabilityPercentage"
                            :label="taxLiabilityPercentageLabel"
                            numberFormat="decimal3"
                            :alvqa="alvqa + '-textfield-tax-liability-percentage'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="RecoupmentPriority"
                            :items="recoupmentPriorityItems" 
                            :label="recoupmentPriorityLabel" 
                            :selection="true"
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-recoupment-priority'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="PublishingStatementsText"
                            :label="publishingStatementsTextLabel"
                            :alvqa="alvqa + '-textfield-publishing-statements-text'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BaseEditPageTextField 
                            :context="context"
                            field="LabelStatementsText"
                            :label="labelStatementsTextLabel"
                            :alvqa="alvqa + '-textfield-label-statements-text'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import { DropdownAzRecoupmentPriority } from '@/assets/dropdowns/alvDropdowns'

export default {
    name: "FinancePanel",
    components: {
        BasePanel,
        BaseEditPageTextarea,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageDatePicker
    },
    data() {
        return {
            context: "AzGroupsFinance",
            alvqa: "az-groups-edit-form-panel-finance"
        }
    },
    computed: {
        taxWithholdingSurchargePercentageLabel() { return this.$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_SURCHARGE_PERCENTAGE') },
        paymentOrderLabel()             { return this.$t('lang_GENERAL_CAPTION_PAYMENT_ORDER') },
        accountHolderNoLabel()          { return this.$t('lang_GENERIC_CAPTION_ACCOUNT_HOLDER') },
        paymentTargetLabel()            { return this.$t('lang_GENERIC_CAPTION_PAYMENT_TARGET') },
        vatIdLabel()                    { return this.$t('lang_GENERIC_CAPTION_VAT_ID') },
        accountNumberLabel()            { return this.$t('lang_GENERAL_CAPTION_IBAN_ACCOUNT_NO') },
        vatRetailLabel()                { return this.$t('lang_AZ_PERSONS_CAPTION_VAT_RETAIL') },
        vatLicenseLabel()               { return this.$t('lang_AZ_PERSONS_CAPTION_VAT_LICENSE') },
        taxOfficeLabel()                { return this.$t('lang_GENERAL_CAPTION_TAX_OFFICE') },
        bicLabel()                      { return this.$t('lang_GENERAL_CAPTION_BIC_SWIFT_ABA') },
        registrationNumberLabel()       { return this.$t('lang_GENERAL_CAPTION_COMPANY_REGISTRATION_NO') },
        taxNumberLabel()                { return this.$t('lang_GENERAL_CAPTION_TAX_NO') },
        bankNameLabel()                 { return this.$t('lang_GENERAL_CAPTION_BANK_NAME') },
        registerCourtLabel()            { return this.$t('lang_GENERAL_CAPTION_REGISTRATION_OFFICE') },
        taxIdNumberLabel()              { return this.$t('lang_GENERAL_CAPTION_TAX_ID_GERMAN') },
        taxWaiverLabel()                { return this.$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER') },
        taxWaiverFromLabel()            { return this.$t("lang_AZ_PERSONS_CAPTION_TAX_WAIVER_FROM") },
        taxWaiverToLabel()              { return this.$t("lang_AZ_PERSONS_CAPTION_TAX_WAIVER_TO") },
        taxWithholdingPercentageLabel() { return this.$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_TAX_PERCENTAGE') },
        // hide this, came from Monopol aka Meisel, nobody is using or understanding what it is
        taxLiabilityPercentageLabel()   { return this.$t('lang_AZ_PERSONS_CAPTION_TAX_LIABILITY_PERCENTAGE') },
        publishingStatementsTextLabel() { return this.$t('lang_AZ_PERSONS_CAPTION_PUBLISHING_STATEMENTS_TEXT') },
        labelStatementsTextLabel()      { return this.$t('lang_AZ_PERSONS_CAPTION_LABEL_STATEMENTS_TEXT') },

        taxWaiverItems() {
            return [
                // if dates FROM-TO are provided (in both cases), is statement run date within interval
                // 
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_NOT_AVAILABLE'), 
                    // should be "taxWaiverRequiredNotProvided"
                    value: "1", 
                    alvqa: this.alvqa + '-dropdown-tax-waiver-not-available'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_AVAILABLE'), 
                    // should be "taxWaiverRequiredProvided"
                    value: "2",
                    alvqa: this.alvqa + '-dropdown-tax-waiver-available'
                }
            ]
        },
        recoupmentPriorityLabel() { return this.$t('lang_AZ_CAPTION_RECOUPMENT_PRIORITY') },
        recoupmentPriorityItems() {
            return DropdownAzRecoupmentPriority.map(item => ({
                text: this.$t(item.text),
                value: item.value,
                alvqa: this.alvqa + '-dropdown-' + item.alvqa
            }))
        },
        taxWaiverValue() {
            return this.$store.getters.getAzGroupsFinanceDetailsTaxWaiver
        },
        withholdingRules() {
            return this.isTaxWaiverRequired(this.taxWaiverValue) ? 'percentDecimal3|required' : 'percentDecimal3'
        }
    },
    watch: {
        taxWaiverValue(newVal) {
            this.maybePrefillWithholding(newVal)
        }
    },
    mounted() {
        this.maybePrefillWithholding(this.taxWaiverValue)
    },
    methods: {
        isTaxWaiverRequired(waiver) {
            return waiver == 1 || waiver == '1' || waiver == 2 || waiver == '2'
        },
        maybePrefillWithholding(waiver) {
            if (!this.isTaxWaiverRequired(waiver)) return
            const country = String(this.$store.getters.getCompanyCountry || '').toUpperCase()
            const currency = String(this.$store.getters.getSelectedCurrency || '').toUpperCase()
            if ((country !== 'DEU' && country !== 'DE') || currency !== 'EUR') return
            const current = this.$store.getters.getAzGroupsFinanceDetailsTaxWithholdingPercentage
            const surcharge = this.$store.getters.getAzGroupsFinanceDetailsTaxWithholdingSurchargePercentage
            if (current !== null && current !== undefined && current !== '') return
            if (surcharge !== null && surcharge !== undefined && surcharge !== '') return
            this.$store.commit(
                'setAzGroupsFinanceDetailsTaxWithholdingPercentage',
                this.$alvPlugin.getNumberLocalization(15, 'decimal3')
            )
            this.$store.commit(
                'setAzGroupsFinanceDetailsTaxWithholdingSurchargePercentage',
                this.$alvPlugin.getNumberLocalization(0.825, 'decimal3')
            )
        }
    }
}
</script>